import { useEffect, useRef } from "react";

export const useScrollAnimation = () => {
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    // Criar o Intersection Observer
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      },
      {
        threshold: 0.1, // Ativar quando 10% do elemento estiver visível
        rootMargin: "0px 0px -50px 0px", // Ativar um pouco antes do elemento aparecer
      }
    );

    // Observar todos os elementos que devem ser animados
    const elementsToAnimate = document.querySelectorAll(
      ".feature-card, .medal-card, .profile-card, .discord-content, .cta-buttons"
    );

    elementsToAnimate.forEach((element) => {
      observerRef.current?.observe(element);
    });

    // Cleanup
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return observerRef.current;
};
